export default "__VITE_ASSET__c313fc6e__"